(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-indossalo-carousel"] && !Shopify.designMode) return;
  try {
    
  function initSvIndossaloCarousel(root) {
    if (!root || root.dataset.svReady === 'true') return;

    const track = root.querySelector('[data-sv-track]');
    const prev = root.querySelector('[data-sv-prev]');
    const next = root.querySelector('[data-sv-next]');
    const slides = Array.from(root.querySelectorAll('.sv-indossalo__slide'));

    if (!track || slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    root.dataset.svReady = 'true';

    const slideStep = () => {
      const firstSlide = slides[0];
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    };

    const go = (direction) => {
      track.scrollBy({ left: slideStep() * direction, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAllSvIndossaloCarousels() {
    document.querySelectorAll('[data-sv-indossalo]').forEach(initSvIndossaloCarousel);
  }

  initAllSvIndossaloCarousels();
  document.addEventListener('shopify:section:load', initAllSvIndossaloCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  function initSvWelcome(root) {
    if (!root || root.dataset.svReady === 'true') return;

    // Sin cuenta atras: la oferta se muestra fija, sin temporizador ni ocultacion.
    if (root.dataset.timer === 'false') {
      root.dataset.svReady = 'true';
      return;
    }

    const storageKey = 'sv_welcome_offer_deadline';
    const minutes = parseFloat(root.dataset.minutes) || 10;
    const durationMs = minutes * 60000;
    let deadline = parseInt(localStorage.getItem(storageKey), 10);

    if (!deadline || isNaN(deadline) || deadline <= Date.now()) {
      deadline = Date.now() + durationMs;
      localStorage.setItem(storageKey, String(deadline));
    }

    root.dataset.svReady = 'true';

    const minutesEl = root.querySelector('[data-sv-minutes]');
    const secondsEl = root.querySelector('[data-sv-seconds]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const diff = deadline - Date.now();

      if (diff <= 0) {
        root.style.display = 'none';
        clearInterval(intervalId);
        return;
      }

      const m = Math.floor(diff / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    tick();
    const intervalId = setInterval(tick, 1000);
  }

  function initAllSvWelcome() {
    document.querySelectorAll('[data-sv-welcome]').forEach(initSvWelcome);
  }

  initAllSvWelcome();
  document.addEventListener('shopify:section:load', initAllSvWelcome);

  } catch(e) { console.error(e); }
})();
})();
